(function () {

  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {

    var jsonEl = document.querySelector('[data-wbp-json]');

    if (!jsonEl) return;

    var data;

    try {

      data = JSON.parse(jsonEl.textContent);

    } catch (e) {

      return;

    }

    var section = document.getElementById('wb-product-' + data.sectionId);

    if (!section || section.dataset.wbpInitialized === 'true') return;

    section.dataset.wbpInitialized = 'true';

    setupGallery(section, data);

    setupVariants(section, data);

    setupAddToCart(section);

    setupStickyBar(section);

    setupAccordions(section);

    setupFullscreen(section);

    setupBis(section);

    setupFade(section);

    setupDescToggle(section);

  }

  function setupGallery(section) {

    var slides = section.querySelector('[data-wbp-slides]');

    var prevBtn = section.querySelector('[data-wbp-prev]');

    var nextBtn = section.querySelector('[data-wbp-next]');

    var thumbs = section.querySelectorAll('[data-wbp-thumb]');

    var currentEl = section.querySelector('[data-wbp-current]');

    var totalEl = section.querySelector('[data-wbp-total]');

    var counterBox = section.querySelector('[data-wbp-counter]');

    if (!slides) return;

    var currentIndex = 0;

    var slideEls = section.querySelectorAll('[data-wbp-slide]');

    var total = slideEls.length;

    section.setAttribute('data-gallery-count', total);

    if (total <= 1 && counterBox) counterBox.style.display = 'none';

    if (total <= 1 && section.getAttribute('data-gallery-mode') === 'grid') {

      section.setAttribute('data-gallery-mode', 'stack');

    }

    if (total <= 0) return;

    if (totalEl) totalEl.textContent = total;

    function goTo(index) {

      if (index < 0 || index >= total) return;

      currentIndex = index;

      var target = slideEls[index];

      var left = target.offsetLeft;

      slides.scrollTo({

        left: left,

        behavior: prefersReduced ? 'auto' : 'smooth'

      });

      updateControls();

    }

    function updateControls() {

      if (prevBtn) prevBtn.disabled = currentIndex === 0;

      if (nextBtn) nextBtn.disabled = currentIndex === total - 1;

      if (currentEl) currentEl.textContent = currentIndex + 1;

      thumbs.forEach(function (thumb) {

        var idx = parseInt(thumb.getAttribute('data-wbp-thumb'), 10);

        thumb.classList.toggle('is-active', idx === currentIndex);

      });

    }

    if (prevBtn) {

      prevBtn.addEventListener('click', function () {

        goTo(currentIndex - 1);

      });

    }

    if (nextBtn) {

      nextBtn.addEventListener('click', function () {

        goTo(currentIndex + 1);

      });

    }

    thumbs.forEach(function (thumb) {

      thumb.addEventListener('click', function () {

        goTo(parseInt(thumb.getAttribute('data-wbp-thumb'), 10));

      });

    });

    var scrollTimer = null;

    slides.addEventListener('scroll', function () {

      if (scrollTimer) return;

      scrollTimer = requestAnimationFrame(function () {

        scrollTimer = null;

        var slideWidth = slides.offsetWidth;

        if (slideWidth <= 0) return;

        var newIndex = Math.round(slides.scrollLeft / slideWidth);

        if (newIndex !== currentIndex && newIndex >= 0 && newIndex < total) {

          currentIndex = newIndex;

          updateControls();

        }

      });

    }, { passive: true });

    section._galleryGoTo = goTo;

    updateControls();

  }

  function setupFullscreen(section) {

    if (section.getAttribute('data-fullscreen') !== 'true') return;

    var modal = document.createElement('div');

    modal.className = 'wb-product__fs-modal';

    modal.setAttribute('role', 'dialog');

    modal.setAttribute('aria-modal', 'true');

    modal.setAttribute('aria-label', 'Image en plein écran');

    modal.innerHTML =

      '<button class="wb-product__fs-close" aria-label="Fermer">' +

        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +

          '<path d="M18 6L6 18M6 6l12 12"/>' +

        '</svg>' +

      '</button>' +

      '<img class="wb-product__fs-img" src="" alt="">';

    document.body.appendChild(modal);

    var fsImg = modal.querySelector('.wb-product__fs-img');

    var closeBtn = modal.querySelector('.wb-product__fs-close');

    var slideEls = section.querySelectorAll('.wb-product__slide');

    slideEls.forEach(function (slide) {

      var img = slide.querySelector('img');

      if (!img) return;

      var btn = document.createElement('button');

      btn.className = 'wb-product__fs-btn';

      btn.setAttribute('aria-label', 'Ouvrir en plein écran');

      btn.innerHTML =

        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +

          '<path d="M8 3H5a2 2 0 00-2 2v3m18 0V5a2 2 0 00-2-2h-3m0 18h3a2 2 0 002-2v-3M3 16v3a2 2 0 002 2h3"/>' +

        '</svg>';

      btn.addEventListener('click', function (event) {

        event.stopPropagation();

        var src = img.getAttribute('src') || '';

        var hiRes = src.indexOf('width=') !== -1 ? src.replace(/width=\d+/, 'width=2400') : src;

        fsImg.src = hiRes;

        fsImg.alt = img.alt || '';

        modal.classList.add('is-open');

        document.body.style.overflow = 'hidden';

      });

      slide.appendChild(btn);

    });

    function closeModal() {

      modal.classList.remove('is-open');

      document.body.style.overflow = '';

      setTimeout(function () {

        if (!modal.classList.contains('is-open')) fsImg.src = '';

      }, 350);

    }

    closeBtn.addEventListener('click', closeModal);

    modal.addEventListener('click', function (event) {

      if (event.target === modal) closeModal();

    });

    document.addEventListener('keydown', function (event) {

      if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();

    });

  }

  function setupVariants(section, data) {

    var product = data.product;

    var variantIdInput = section.querySelector('[data-wbp-variant-id]');

    var priceEl = section.querySelector('[data-wbp-price]');

    var compareEl = section.querySelector('[data-wbp-compare]');

    var atcBtn = section.querySelector('[data-wbp-atc]');

    var atcText = section.querySelector('[data-wbp-atc-text]');

    var atcPriceEl = section.querySelector('[data-wbp-atc-price]');

    var atcCompareEl = section.querySelector('[data-wbp-atc-compare]');

    var stockEl = section.querySelector('[data-wbp-stock]');

    var stockText = section.querySelector('[data-wbp-stock-text]');

    var stickyPrice = section.querySelector('[data-wbp-sticky-price]');

    var stickyCompare = section.querySelector('[data-wbp-sticky-compare]');

    var bisBlock = section.querySelector('[data-wbp-bis]');

    var dynamicBtn = section.querySelector('.wb-product__dynamic-btn');

    if (!product || !product.variants) return;

    var selectedOptions = [];

    var firstVariant = null;

    for (var i = 0; i < product.variants.length; i++) {

      if (product.variants[i].id === data.initialVariantId) {

        firstVariant = product.variants[i];

        break;

      }

    }

    if (firstVariant && firstVariant.options) {

      selectedOptions = firstVariant.options.slice();

    }

    setupCustomSelects(section);

    var optionBtns = section.querySelectorAll('[data-option-value]');

    optionBtns.forEach(function (btn) {

      btn.addEventListener('click', function () {

        if (btn.classList.contains('is-unavailable')) return;

        var fieldset = btn.closest('[data-option-index]');

        if (!fieldset) return;

        var optionIndex = parseInt(fieldset.getAttribute('data-option-index'), 10);

        var value = btn.getAttribute('data-option-value');

        selectedOptions[optionIndex] = value;

        fieldset.querySelectorAll('[data-option-value]').forEach(function (button) {

          button.classList.toggle('is-selected', button.getAttribute('data-option-value') === value);

        });

        var customSelect = fieldset.querySelector('[data-wbp-custom-select]');

        var current = fieldset.querySelector('[data-wbp-select-current]');

        if (customSelect && current) {

          current.textContent = btn.getAttribute('data-option-label') || value;

          customSelect.classList.remove('is-open');

          var trigger = customSelect.querySelector('[data-wbp-select-trigger]');

          if (trigger) trigger.setAttribute('aria-expanded', 'false');

        }

        processVariantChange();

      });

    });

    function setupCustomSelects(scope) {

      var selects = scope.querySelectorAll('[data-wbp-custom-select]');

      selects.forEach(function (select) {

        var trigger = select.querySelector('[data-wbp-select-trigger]');

        if (!trigger) return;

        trigger.addEventListener('click', function () {

          var isOpen = select.classList.contains('is-open');

          closeAllSelects(scope);

          select.classList.toggle('is-open', !isOpen);

          trigger.setAttribute('aria-expanded', String(!isOpen));

        });

      });

      document.addEventListener('click', function (event) {

        if (!event.target.closest('[data-wbp-custom-select]')) {

          closeAllSelects(scope);

        }

      });

      document.addEventListener('keydown', function (event) {

        if (event.key === 'Escape') {

          closeAllSelects(scope);

        }

      });

    }

    function closeAllSelects(scope) {

      scope.querySelectorAll('[data-wbp-custom-select]').forEach(function (select) {

        select.classList.remove('is-open');

        var trigger = select.querySelector('[data-wbp-select-trigger]');

        if (trigger) trigger.setAttribute('aria-expanded', 'false');

      });

    }

    function processVariantChange() {

      var variant = findVariant(product.variants, selectedOptions);

      if (variant) updateVariant(variant);

      updateUnavailableOptions();

    }

    function findVariant(variants, options) {

      for (var i = 0; i < variants.length; i++) {

        var variant = variants[i];

        var match = true;

        for (var j = 0; j < options.length; j++) {

          if (variant.options[j] !== options[j]) {

            match = false;

            break;

          }

        }

        if (match) return variant;

      }

      return null;

    }

    function updateUnavailableOptions() {

      var fieldsets = section.querySelectorAll('[data-option-index]');

      fieldsets.forEach(function (fieldset) {

        var optionIndex = parseInt(fieldset.getAttribute('data-option-index'), 10);

        var buttons = fieldset.querySelectorAll('[data-option-value]');

        buttons.forEach(function (button) {

          var testOptions = selectedOptions.slice();

          testOptions[optionIndex] = button.getAttribute('data-option-value');

          var matchedVariant = findVariant(product.variants, testOptions);

          var unavailable = matchedVariant && matchedVariant.available === false;

          button.classList.toggle('is-unavailable', !!unavailable);

          button.setAttribute('aria-disabled', unavailable ? 'true' : 'false');

        });

      });

    }

    function formatMoney(cents) {

      var format = data.moneyFormat || '{{amount}}';

      var value = cents / 100;

      var amount = value.toFixed(2).replace('.', ',');

      var amountNoDecimals = Math.round(value).toString();

      return format

        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount)

        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals)

        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)

        .replace(/\{\{\s*amount\s*\}\}/g, value.toFixed(2));

    }

    function updateVariant(variant) {

      if (variantIdInput) variantIdInput.value = variant.id;

      var formattedPrice = formatMoney(variant.price);

      var hasPromo = variant.compare_at_price && variant.compare_at_price > variant.price;

      var formattedCompare = hasPromo ? formatMoney(variant.compare_at_price) : '';

      if (priceEl) priceEl.textContent = formattedPrice;

      if (stickyPrice) stickyPrice.textContent = formattedPrice;

      if (compareEl) {

        if (hasPromo) {

          compareEl.textContent = formattedCompare;

          compareEl.style.display = '';

        } else {

          compareEl.style.display = 'none';

        }

      }

      if (stickyCompare) {

        if (hasPromo) {

          stickyCompare.textContent = formattedCompare;

          stickyCompare.style.display = '';

        } else {

          stickyCompare.style.display = 'none';

        }

      }

      if (atcPriceEl) atcPriceEl.textContent = formattedPrice;

      if (atcCompareEl) {

        if (hasPromo) {

          atcCompareEl.textContent = formattedCompare;

          atcCompareEl.style.display = '';

        } else {

          atcCompareEl.style.display = 'none';

        }

      }

      if (atcBtn && atcText) {

        var defaultText = atcBtn.getAttribute('data-atc-text-default') || atcText.textContent || 'AJOUTER AU PANIER';

        var soldText = atcBtn.getAttribute('data-atc-text-sold') || 'ÉPUISÉ';

        if (variant.available) {

          atcBtn.disabled = false;

          atcText.textContent = defaultText;

          if (bisBlock) bisBlock.style.display = 'none';

          if (dynamicBtn) dynamicBtn.style.display = '';

        } else {

          atcBtn.disabled = true;

          atcText.textContent = soldText;

          if (bisBlock) bisBlock.style.display = '';

          if (dynamicBtn) dynamicBtn.style.display = 'none';

        }

      }

      if (stockEl && stockText) {

        if (!variant.available) {

          stockEl.setAttribute('data-state', 'out');

          stockText.textContent = 'Rupture de stock';

        } else {

          var management = data.management[variant.id];

          var quantity = data.inventory[variant.id];

          if (management === 'shopify') {

            if (quantity <= 5) {

              stockEl.setAttribute('data-state', 'low');

              stockText.textContent = 'Plus que ' + quantity + ' en stock';

            } else if (quantity <= 15) {

              stockEl.setAttribute('data-state', 'medium');

              stockText.textContent = 'Stock limité';

            } else {

              stockEl.setAttribute('data-state', 'in');

              stockText.textContent = 'En stock';

            }

          } else {

            stockEl.setAttribute('data-state', 'in');

            stockText.textContent = 'En stock';

          }

        }

      }

      if (variant.featured_media && section._galleryGoTo) {

        var mediaId = variant.featured_media.id;

        var slideEls = section.querySelectorAll('[data-wbp-slide]');

        slideEls.forEach(function (slide, index) {

          if (parseInt(slide.getAttribute('data-media-id'), 10) === mediaId) {

            section._galleryGoTo(index);

          }

        });

      }

      var url = new URL(window.location.href);

      url.searchParams.set('variant', variant.id);

      window.history.replaceState({}, '', url.toString());

      document.dispatchEvent(new CustomEvent('wbp:variant-change', {
        bubbles: true,
        detail: {
          sectionId: data.sectionId,
          variant: variant,
          price: variant.price,
          compareAtPrice: variant.compare_at_price || 0
        }
      }));

    }

    if (firstVariant) {

      updateVariant(firstVariant);

      updateUnavailableOptions();

    }

  }

  function setupAddToCart(section) {

    var form = section.querySelector('.wb-product__buy form');

    var atcBtn = section.querySelector('[data-wbp-atc]');

    var stickyAtc = section.querySelector('[data-wbp-sticky-atc]');

    if (!form || !atcBtn) return;

    function triggerSuccess(btn) {

      btn.classList.remove('is-loading');

      btn.classList.add('is-success');

      setTimeout(function () {

        btn.classList.remove('is-success');

      }, 1800);

    }

    function clearLoading() {

      atcBtn.classList.remove('is-loading');

      if (stickyAtc) stickyAtc.classList.remove('is-loading');

    }

    function getCartRoute() {

      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {

        return window.Shopify.routes.root + 'cart/add.js';

      }

      return '/cart/add.js';

    }

    function handleSubmit(event) {

      event.preventDefault();

      if (atcBtn.disabled || atcBtn.classList.contains('is-loading')) return;

      var bundle = null;

      if (typeof section._wbuqBuildCart === 'function') {

        bundle = section._wbuqBuildCart(form);

      }

      if (bundle && bundle.handled && !bundle.valid) {

        return;

      }

      atcBtn.classList.add('is-loading');

      if (stickyAtc) stickyAtc.classList.add('is-loading');

      var requestOptions = {

        method: 'POST',

        headers: {

          Accept: 'application/json',

          'X-Requested-With': 'XMLHttpRequest'

        }

      };

      if (bundle && bundle.handled && bundle.valid) {

        requestOptions.headers['Content-Type'] = 'application/json';

        requestOptions.body = JSON.stringify({ items: bundle.items });

      } else {

        requestOptions.body = new FormData(form);

      }

      fetch(getCartRoute(), requestOptions)

        .then(function (response) {

          return response.json().then(function (payload) {

            if (!response.ok) {

              var message = payload && payload.description ? payload.description : 'Impossible d’ajouter le produit au panier.';

              throw new Error(message);

            }

            return payload;

          });

        })

        .then(function (payload) {

          triggerSuccess(atcBtn);

          if (stickyAtc) triggerSuccess(stickyAtc);

          document.dispatchEvent(new CustomEvent('cart:updated', {

            bubbles: true,

            detail: {

              response: payload,

              bundle: bundle && bundle.handled ? bundle : null

            }

          }));

          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {

            bubbles: true,

            detail: {

              response: payload,

              bundle: bundle && bundle.handled ? bundle : null

            }

          }));

        })

        .catch(function (error) {

          clearLoading();

          console.error('[WB Product]', error);

        });

    }

    form.addEventListener('submit', handleSubmit);

    if (stickyAtc) {

      stickyAtc.addEventListener('click', function () {

        if (atcBtn.disabled || atcBtn.classList.contains('is-loading')) return;

        form.dispatchEvent(new Event('submit', {

          cancelable: true,

          bubbles: true

        }));

      });

    }

  }

  function setupStickyBar(section) {

    var stickyBar = section.querySelector('[data-wbp-sticky-bar]');

    var atcBtn = section.querySelector('[data-wbp-atc]');

    if (!stickyBar || !atcBtn) return;

    var ticking = false;

    function onScroll() {

      if (ticking) return;

      ticking = true;

      requestAnimationFrame(function () {

        ticking = false;

        var rect = atcBtn.getBoundingClientRect();

        if (rect.bottom <= 0) {

          stickyBar.classList.add('is-visible');

        } else {

          stickyBar.classList.remove('is-visible');

        }

      });

    }

    window.addEventListener('scroll', onScroll, { passive: true });

    onScroll();

  }

  function setupAccordions(section) {

    var toggleDescBtn = section.querySelector('[data-wbp-toggle-desc]');

    if (toggleDescBtn) {

      toggleDescBtn.addEventListener('click', function () {

        var descAccordion = section.querySelector('[data-acc-description]');

        if (descAccordion) {

          descAccordion.open = true;

          var y = descAccordion.getBoundingClientRect().top + window.scrollY - 80;

          window.scrollTo({

            top: y,

            behavior: prefersReduced ? 'auto' : 'smooth'

          });

        }

      });

    }

  }

  function setupDescToggle(section) {

    var btn = section.querySelector('[data-wbp-toggle-desc-inline]');

    if (!btn) return;

    var inner = section.querySelector('[data-wbp-desc-inner]');

    var full = section.querySelector('[data-wbp-desc-full]');

    if (!inner || !full) return;

    btn.addEventListener('click', function () {

      inner.style.display = 'none';

      full.style.display = 'block';

      btn.style.display = 'none';

    });

  }

  function setupBis(section) {

    var bisToggle = section.querySelector('[data-wbp-bis-toggle]');

    var bisForm = section.querySelector('[data-wbp-bis-form]');

    if (!bisToggle || !bisForm) return;

    bisToggle.addEventListener('click', function () {

      bisForm.style.display = 'block';

      bisToggle.style.display = 'none';

    });

  }

  function setupFade(section) {

    var fadeEls = section.querySelectorAll('.wb-fade');

    if (!fadeEls.length) return;

    if (prefersReduced) {

      fadeEls.forEach(function (el) {

        el.classList.add('is-visible');

      });

      return;

    }

    var observer = new IntersectionObserver(function (entries) {

      entries.forEach(function (entry) {

        if (entry.isIntersecting) {

          entry.target.classList.add('is-visible');

          observer.unobserve(entry.target);

        }

      });

    }, {

      threshold: 0.08,

      rootMargin: '0px 0px -32px 0px'

    });

    fadeEls.forEach(function (el, index) {

      if (!el.style.transitionDelay) {

        el.style.transitionDelay = Math.min(index * 0.05, 0.4) + 's';

      }

      observer.observe(el);

    });

  }

  document.addEventListener('shopify:section:load', function (event) {

    var section = event.target.querySelector('[data-wbp-json]')

      ? event.target

      : document;

    var jsonEl = section.querySelector('[data-wbp-json]');

    if (!jsonEl) return;

    var productSection = event.target.querySelector('.wb-product');

    if (productSection) {

      productSection.dataset.wbpInitialized = 'false';

    }

    init();

  });

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', init);

  } else {

    init();

  }

})();
